import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import SignInModalMessage from "../../../presentational/customerItems/SignInModalMessage";
import NotifyMeButton from "../../../presentational/customerItems/NotifyMeButton";
import {
  getIsOptedIn,
  shouldShowNotifyMe
} from "../../../../state/modules/backInStock/selectors";
import { notificationChange } from "../../../../state/modules/backInStock/actions";
import { showSizeSelectPrompt } from "../../../../state/modules/savedItems/actions";
import {
  clearNotifyMeWarningForSession,
  storeNotifyMeWarningForSession
} from "../../../../services/backInStock/notifyMeWarning";
import { getIsPriority } from "../../../../state/modules/loyalty/selectors";

const ConnectedNotifyMeButton = ({
  id: itemId,
  variantId,
  isAuthenticated,
  isProductInStock,
  isVariantInStock,
  customerAccess,
  ...rest
}) => {
  const dispatch = useDispatch();

  const isPriority = useSelector(getIsPriority);
  const [isOptedIn, setIsOptedIn] = useState(
    useSelector(state => getIsOptedIn(state, variantId))
  );

  const isButtonShowing = shouldShowNotifyMe({
    customerAccess,
    isProductInStock,
    isVariantInStock
  });

  const [isModalOpen, setModalOpen] = useState(false);

  const onClick = () => {
    if (isAuthenticated) {
      if (!variantId) {
        return dispatch(showSizeSelectPrompt({ itemId }));
      }

      dispatch(notificationChange({ variantId, isOptedIn, isPriority }));
      setIsOptedIn(prev => !prev);
    } else {
      storeNotifyMeWarningForSession();
      setModalOpen(true);
    }
  };

  const onClose = () => {
    setModalOpen(false);
    clearNotifyMeWarningForSession();
  };

  return (
    <>
      <NotifyMeButton
        {...{ isButtonShowing, isOptedIn, isPriority, onClick, ...rest }}
      />
      {isModalOpen ? <SignInModalMessage onClosed={onClose} /> : null}
    </>
  );
};

ConnectedNotifyMeButton.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  isProductInStock: PropTypes.bool.isRequired,
  isVariantInStock: PropTypes.bool,
  id: PropTypes.string.isRequired,
  variantId: PropTypes.number,
  isPriority: PropTypes.bool,
  customerAccess: PropTypes.string
};

export default ConnectedNotifyMeButton;
